import { useState } from 'react';

import { useServerClient } from '../useServerClient';
import { useServerParams } from '../useServerParams';

export const roleTypes = {
    role: "role",
}

export const targetTypes = {
    role: "role",
}

export function useUserRoles({ 
    roleType: _roleType, 
    targetType: _targetType
}) {

    const [roleType, setRoleType] = useState(_roleType);
    const [targetType, setTargetType] = useState(_targetType);

    const { makeCall, getError } = useServerClient();
    const { getListsUrl, getUrlWithDataTypes, _operatorDef: filterOperatorTypes } = useServerParams();

    const [isLoading, setIsLoading] = useState(false)

    const endpoint1 = "role";
    const endpoint2 = "roles"

    const list = async (props) => {

        setIsLoading(true);

        try {

            let url = getListsUrl(`${endpoint2}/${roleType}`, props);

            // check override 
            // if (props?.userType) {
            //     url = getListsUrl(`${endpoint2}/${props.userType}`, props);
            // }

            // if (targetType) {
            //     url = getListsUrl(`${endpoint2}/${userType}/${targetType}`, props);
            // }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }
    }

    const create = async ({ data, targetType: overrideTargetType }) => {

        setIsLoading(true)

        try {

            let url = `${endpoint1}`;

            // if (overrideRoleType) {
            //     url = `${endpoint1}/${overrideRoleType}`;
            // }

            let postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            if (overrideTargetType) postData.scope.target = overrideTargetType

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const update = async ({ id, data, targetType: overrideTargetType }) => {

        setIsLoading(true)

        try {

            let url = `${endpoint1}/${id}`

            // if (overrideRoleType) {
            //     url = `${endpoint1}/${overrideRoleType}/${id}`
            // }

            const postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            if (overrideTargetType) postData.scope.target = overrideTargetType

            const response = await makeCall({
                url,
                method: "PUT",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const changePermission = async ({ id, data, targetType: overrideTargetType }) => {

        setIsLoading(true)

        try {

            let url = `${endpoint1}/change/${id}`

            // if (overrideRoleType) {
            //     url = `${endpoint1}/${overrideRoleType}/${id}`
            // }

            const postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            if (overrideTargetType) postData.scope.target = overrideTargetType

            const response = await makeCall({
                url,
                method: "PUT",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const remove = async ({ ids, targetType: overrideTargetType }) => {

        setIsLoading(true);

        if (ids.length <= 0) {
            throw getError(false, `Please select at least (1) items`)
        }

        try {

            let url = `${endpoint2}/delete`

            // if (overrideUserType) {
            //     url = `${endpoint1}/${overrideUserType}/delete`
            // }

            const postData = {
                scope: {
                    target: targetType
                },
                payload: {
                    ids
                }
            }

            if (overrideTargetType) postData.scope.target = overrideTargetType

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const get = async ({ id, roleType: overrideRoleType, dataTypesArray = [] }) => {

        setIsLoading(true);

        try {

            let url = getUrlWithDataTypes(`${endpoint1}/${roleType}/${id}`, dataTypesArray)

            if (overrideRoleType) {
                url = getUrlWithDataTypes(`${endpoint1}/${overrideRoleType}/${id}`, dataTypesArray)
            }

            // if (targetType) {
            //     url = getUrlWithDataTypes(`${endpoint1}/${userType}/${targetType}/${id}`, dataTypesArray)
            // }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    return {
        isLoading,
        filterOperatorTypes,
        roleTypes,
        targetTypes,
        list,
        get,
        create,
        changePermission,
        update,
        remove
    }
}